module.exports = __webpack_public_path__ + "img/蒙版组 151.0c9890dc.png";